import { Injectable } from '@angular/core';
import { IGenericLabelValueEnum } from '@shared/interface/generic';

@Injectable({
  providedIn: 'root',
})
export class InterfaceDataMapperService {
  labelValueEnumMapper<T>(data: T) {
    if (!data) return undefined;
    return this.mapObjectLabelValue(data);
  }

  mapObjectLabelValue(data: Record<string, any>) {
    return Object.entries(data)
      .filter(([, value]) => value !== null && value !== undefined)
      .map(([key, value]) => {
        return <IGenericLabelValueEnum>{
          label: key,
          value: value,
        };
      });
  }
}
